export default {
  computed: {
    appliedFilters() {
      return this.$store.getters['filter/getAppliedFilters']
    },
    hasAppliedFilters() {
      return (
        this.appliedFilters &&
        this.appliedFilters.toString().replace(this.removeAppliedFiltersRegex, '') !== ''
      )
    },
    isOpenFundraising() {
      return this.appliedFilters && this.appliedFilters.has('open_fundraising')
    }
  },
  data() {
    return {
      removeAppliedFiltersRegex: /(open_fundraising=true&?)|(limit=[0-9]*&?)|(offset=[0-9]*&?)/g
    }
  }
}
